<template>
  <div class="table-wrap">
    <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="exchangeUser" label="兑换者"></el-table-column>
      <el-table-column prop="exchangeTime" label="兑换时间"></el-table-column>
      <el-table-column prop="receiveUser" label="兑换对象"></el-table-column>
      <el-table-column prop="receiptType" label="兑换产品" :formatter="formateProduct"></el-table-column>
      <el-table-column prop="num" label="兑换数量"></el-table-column>
      <el-table-column prop="note" label="订单备注"></el-table-column>
      <el-table-column prop="region" label="收货地址" :formatter="formateRegion"></el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
        :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import CouponApi from '@/api/coupon.js';
  export default {
    data() {
      return {
        tableData: [],
        curPage:1,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        pageIndex: 1,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      formateProduct(row, index) {
        if (row.receiptType == 1) {
          return "ZPOS";
        } else if (row.receiptType == 2) {
          return "FPOS ";
        } else if (row.receiptType == 3) {
          return 'ZPOS-买断版'
        } else if (row.receiptType == 4) {
          return 'FPOS-买断版'
        } else if (row.receiptType == 5) {
          return '和融通'
        } else if (row.receiptType == 6) {
          return '合利宝'
        } else if (row.receiptType == 7) {
          return '电银'
        } else if (row.receiptType == 8) {
          return '联动支付'
        }
      },
      formateRegion(row, index) {
        let region = row.region
        return region.province + region.city + region.region + region.detail
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        CouponApi.couponRecords(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.records;
            self.totalDataNumber = res.data.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/records.vue